/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface ILocalizedLinkDisplayModel {
  link?: null | string;
  localeCode?: null | string;
}
export class LocalizedLinkDisplayModel extends BaseModel implements ILocalizedLinkDisplayModel {
  link?: null | string;
  localeCode?: null | string;
}
class BaseLocalizedLinkDisplayModelFormGroup extends FormGroup {
  private static _instance: LocalizedLinkDisplayModelFormGroup;
  
  public static get Instance(): LocalizedLinkDisplayModelFormGroup {
    this._instance = new LocalizedLinkDisplayModelFormGroup({
      link: new FormControl(null),
      localeCode: new FormControl(null),
    });

    return this._instance;
  }
}


export class LocalizedLinkDisplayModelFormGroup extends BaseLocalizedLinkDisplayModelFormGroup {
  public get Link(): FormControl {
    return this.controls["link"] as FormControl;
  }
  public get LocaleCode(): FormControl {
    return this.controls["localeCode"] as FormControl;
  }
  

}

export module LocalizedLinkDisplayModelForm
  {
    export class FormFields
    {
      static _link: string = "link";
      static _localeCode: string = "localeCode";
    }
  }

